// ====================================================================
// CLIENT FOLLOW-UP CRM - MAIN ENTRY POINT
// ====================================================================

import { initTheme, toggleTheme, initGlobalSearch } from './js/ui.js';
import { initRouter } from './js/router.js';
import { logout } from './js/auth.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Theme
  initTheme();
  document.getElementById('btn-theme-toggle')?.addEventListener('click', toggleTheme);

  // Initialize Global Instant Search
  initGlobalSearch();

  // Mobile Drawer Toggle
  const sidebar = document.getElementById('app-sidebar');
  document.getElementById('btn-mobile-toggle')?.addEventListener('click', () => {
    sidebar?.classList.toggle('open');
  });

  // Logout Handler
  document.getElementById('btn-logout')?.addEventListener('click', () => {
    logout();
  });

  // Initialize Router
  initRouter();
});
